import { RootState } from '@Store';
import { IMasterData } from '@Store/MasterData/types';

export const selectMasterData = (store: RootState): IMasterData =>
  store.masterData.general;
